module.exports = __webpack_public_path__ + "static/media/efsgroup.55db1438.jpg";